var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "span",
        { on: { click: _vm.startConfirmingPassword } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("jet-dialog-modal", {
        attrs: { show: _vm.confirmingPassword },
        on: {
          close: function ($event) {
            _vm.confirmingPassword = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _vm._v(
                  "\n            " + _vm._s(_vm.content) + "\n\n            "
                ),
                _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c("jet-input", {
                      ref: "password",
                      staticClass: "mt-1 block w-3/4",
                      attrs: { type: "password", placeholder: "Password" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.confirmPassword.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password",
                      },
                    }),
                    _vm._v(" "),
                    _c("jet-input-error", {
                      staticClass: "mt-2",
                      attrs: { message: _vm.form.error },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "jet-secondary-button",
                  {
                    nativeOn: {
                      click: function ($event) {
                        _vm.confirmingPassword = false
                      },
                    },
                  },
                  [_vm._v("\n                Nevermind\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "jet-button",
                  {
                    staticClass: "ml-2",
                    class: { "opacity-25": _vm.form.processing },
                    attrs: { disabled: _vm.form.processing },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.confirmPassword.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.button) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }